import { observer } from "mobx-react-lite";
import HomeFooter from './HomeFooter';
import 'e.sic-platform.webclient/src/pages/help/components/composition.scss';

export default observer(function Footer() {
    return <HomeFooter />;
})
